import 'slick-carousel';

(function($) {

  /**
   * initializeBlock
   *
   * Adds custom JavaScript to the block HTML.
   *
   * @param   object $block The block jQuery element.
   * @param   object attributes The block attributes (only available when editing).
   * @return  void
   */
  var initializeBlock = function( $block ) {
    $block.find('.js-slider').slick({
        arrows: true,
        dots: true,
      }
    );
  }

  // Initialize each block on page load (front end).
  $(document).ready(function(){
      $('.acf-block-newsslider').each(function(){
          initializeBlock( $(this) );
      });
  });

  // Initialize dynamic block preview (editor).
  if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=newsslider', initializeBlock );
  }
})( jQuery );


// WEBPACK FOOTER //
// ./scripts/acf-block-slider.js